export const VECTOR_ERROR_CODE = {
  // 입력 파라미터가 유효하지 않은 경우
  INVALID_INPUT: 'VECTOR_INVALID_INPUT',
  // SVG 문자열을 파싱하지 못한 경우
  SVG_PARSE_FAILED: 'VECTOR_SVG_PARSE_FAILED',
  // SVG에 path 요소가 전혀 없는 경우
  SVG_PATH_NOT_FOUND: 'VECTOR_SVG_PATH_NOT_FOUND',
  // SVG에 path 요소가 여러 개 존재하는 경우
  SVG_MULTIPLE_PATHS: 'VECTOR_SVG_MULTIPLE_PATHS',
  // path 요소에 d 속성이 누락된 경우
  SVG_PATH_MISSING_D: 'VECTOR_SVG_PATH_MISSING_D',
  // svgson → Paper Path 변환이 실패한 경우
  PAPER_CONVERSION_FAILED: 'VECTOR_PAPER_CONVERSION_FAILED',
  // Paper Path 변환 결과가 비어 있는 경우
  PAPER_PATH_EMPTY: 'VECTOR_PAPER_PATH_EMPTY',
  // Paper Path 변환 결과가 여러 개인 경우
  PAPER_PATH_MULTIPLE: 'VECTOR_PAPER_PATH_MULTIPLE',
  // Paper Path 변환 결과가 올바르지 않은 경우
  PAPER_PATH_INVALID: 'VECTOR_PAPER_PATH_INVALID',
  // 오프셋 연산 결과가 비어 있는 경우
  OFFSET_EMPTY_RESULT: 'VECTOR_OFFSET_EMPTY_RESULT',
  // 오프셋 처리 중 알 수 없는 오류가 발생한 경우
  OFFSET_PROCESS_FAILED: 'VECTOR_OFFSET_PROCESS_FAILED',
} as const;

export type VectorErrorCode = (typeof VECTOR_ERROR_CODE)[keyof typeof VECTOR_ERROR_CODE];
